/* eslint-disable */


import actions from './actions'

export default function ProposalDetailsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PROPOSALDETAIL_WORKING_HOUR:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PROPOSALDETAIL_WORKING_HOUR:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PROPOSALDETAIL_WORKING_HOUR:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PROPOSALDETAIL_WORKING_HOUR:
      return {
        ...state,
        editing: { proposalDetailID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PROPOSALDETAIL_WORKING_HOUR_RECIEVED ||
      actions.UPDATE_PROPOSALDETAIL_WORKING_HOUR_RECIEVED ||
      actions.DELETE_PROPOSALDETAIL_WORKING_HOUR_RECIEVED:
      return {
        ...state,
        editing: { proposalDetailID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
